export default __webpack_public_path__ + "static/media/milestone 150.f386d662.svg";